import React, { useEffect } from "react";
import { push } from "connected-react-router";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { FullScreenLoader } from "../../../components/Loaders/FullScreenLoader";
import { ScopedVisitorLoader } from "../../../components/Loaders/ScopedVisitorLoader";
import { FullNetwork } from "../../../redux/Network/network.selectors";
import { SmartContainer, Stack } from "../../../styles/Containers";
import { StyledH1, StyledP } from "../../../styles/StyledHTML";
import { EmptyMessage } from "../../components/Empty/EmptyMessage";
import { IconLock } from "../../Icons";
import { useActiveItem } from "../../services/CaptureCollabService";
import { AssetsList } from "../Assets/AssetsList";
import { getView } from "./redux/views.actions";
import { FullViews } from "./redux/views.selectors";
import { ViewAssetsList } from "./ViewAssetslist";
export const PublicView = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const fullNetwork = FullNetwork();
    const { activeItem, setActiveItem, activeItemError } = useActiveItem({ id, model: 'View', selector: FullViews, getAction: getView })
    const auth = useSelector(state => state.auth)

    useEffect(() => {
        if (!activeItem) return;

    }, [activeItem])

    const handleSelect = (item) => {
        dispatch(push(`/asset/${item.id}`))
        // setActiveAsset(item);
        // setOpenViewer(true);
    }

    const formatFilters = (f) => {

        const fom = {}
        const x = Object.keys(f)?.map(key => {
            if (activeItem?.meta?.filters[key].length > 0) fom[key] = JSON.stringify(activeItem?.meta?.filters[key]);
            return key;
        })
        return fom;
    }

    if (activeItemError) return (<EmptyMessage title={activeItemError} icon={<IconLock />} />)
    if (!activeItem) return (<FullScreenLoader />)

    // We Can't Do Anything Until we have the Network and Account Session.
    if (!auth?.me && auth?.withAccount !== true) return (<ScopedVisitorLoader networkId={fullNetwork.network.id} accountId={activeItem.aid} />)

    return (
        <Stack flex align="center" justify="center" padding={10} direction="column">
            {activeItem && activeItem?.meta?.sharable === true && (
                <Stack width="100%">
                    <StyledH1 textAlign="center">{activeItem.name}</StyledH1>
                    <SmartContainer width="100%">
                        <ViewAssetsList view={activeItem} />
                    </SmartContainer>
                </Stack>
            )}
            {(!activeItem || activeItem?.meta?.sharable !== true) && (
                <EmptyMessage title="Nothing to see here">
                    <StyledP>The View you are looking for doesn't exist anymore.</StyledP>
                </EmptyMessage>
            )}
        </Stack>
    )
}